import React from 'react'
import FiltrosAdicionadosCentroCusto from './FiltrosAdicionadosCentroCusto';
import Filtro from '../comum/Filtro'
import PainelFiltragem from '../comum/PainelFiltragem'
import FiltroCentroCusto from './FiltroCentroCusto';

export const PainelFiltroCentroCusto = () => (
  <Filtro PainelFiltro={FiltroCentroCusto}/>
);

const PainelFiltrosCentroCusto = () => (
  <PainelFiltragem
    Filtro={PainelFiltroCentroCusto}
    FiltrosAdicionados={FiltrosAdicionadosCentroCusto}/>
)

export default PainelFiltrosCentroCusto
